<template>
  <i-card am-activity-instruction>
    Activity
    <div
      v-if="store.state.activity.loading"
      class="_margin-top:1/4 _align-self:stretch _display:flex _justify-content:center _align-items:center _height:100%"
    >
      <ILoader color="primary" size="sm" />
    </div>
    <div
      v-else-if="store.state.activity.error"
      class="_display:flex _justify-content:center _align-items:center _flex-direction:column"
    >
      <p>Something went wrong, activity didn't load</p>
      <IButton
        size="sm"
        color="primary"
        @click="store.dispatch('activity/getActivity', `instruction_id=${$route.params.id}`)"
      >
        Reload
      </IButton>
    </div>
    <div v-else-if="!store.state.activity.data?.length">
      <p class="_font-size:sm">no activities</p>
    </div>
    <template v-else>
      <div
        v-for="activity in store.state.activity.data"
        :key="activity"
        class="_margin-top:1 _margin-bottom:1"
      >
        <ICard size="sm">
          <template #header>
            <p class="_font-size:sm">
              <span class="_font-weight:bold">
                {{ activity.user.name === store.state.user.userInfo.name ? 'You' : activity.user.name }}
              </span> edited this record
            </p>
            <p class="_font-size:sm">{{ dateConvert(activity.updated_at) }}</p>
          </template>
          <div v-for="diff in activity.diff" :key="diff">
            <div
              v-if="
                diff[0] === 'content' ||
                diff[0] === 'step_name' ||
                diff[0] === 'step'
              "
            >
              <p v-if="diff[0] === 'content'" class="_font-weight:bold _margin:0">Content</p>
              <p v-if="diff[0] === 'step'" class="_font-weight:bold _margin:0">Step</p>
              <p v-if="diff[0] === 'step_name'" class="_font-weight:bold _margin:0">Step name</p>
              <div am-diff-text>
                <span
                  v-for="item in dmp.diff_main(diff[1].toString(), diff[2].toString())"
                  :key="item"
                  :am-text="item[0]"
                >
                  {{item[1]}}
                </span>
              </div>
            </div>
            <div v-else-if="diff[0] === 'algs'">
              <p class="_font-weight:bold _margin:0">Algoritm</p>
              <div
                v-for="arr in diff[1]"
                :key="arr"
              >
                <p v-if="!diff[2]?.includes(arr)" line-through class="_margin:0">
                  {{ arr }}
                </p>
              </div>
              <div
                v-for="arr in diff[2]"
                :key="arr"
              >
                <p v-if="!diff[1]?.includes(arr)" class="_margin:0">
                  {{ arr }}
                </p>
              </div>
            </div>
            <div v-else-if="diff[0] === 'multiple_algs'">
              <p class="_font-weight:bold _margin:0">Algoritm number</p>
              <i-radio-group
                v-model="diff[2]"
                class="_margin-bottom:0"
                disabled
              >
                <i-radio :value="1">
                  <span>should match<b class="_margin-right:1/4 _margin-left:1/4">all</b>algorithms</span>
                </i-radio>
                <i-radio :value="0">
                  <span>should match<b class="_margin-right:1/4 _margin-left:1/4"> any of </b>algorithms</span>
                </i-radio>
              </i-radio-group>
            </div>
            <div v-else-if="diff[0] === 'status'">
              <p class="_font-weight:bold _margin:0">IsActive</p>
              <IToggle disabled :modelValue="setIsActive(diff[2])" />
            </div>
            <div v-else-if="diff[0] === 'element_types'">
              <p class="_font-weight:bold _margin:0">Compatible types</p>
              <div
                v-for="value in diff[1]"
                :key="value"
              >
                <i-badge
                  color="danger"
                  v-if="!diff[2].includes(value)"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0" line-through>
                    {{ value }}
                  </p>
                </i-badge>
              </div>
              <div
                v-for="value in diff[2]"
                :key="value"
              >
                <i-badge
                  v-if="diff[1].includes(value)"
                  color="success"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0">
                    {{ value }}
                  </p>
                </i-badge>
              </div>
            </div>
            <div v-else-if="diff[0] === 'cond'">
              <p class="_font-weight:bold _margin:0">Conditions</p>
              <div v-for="(and, index) in diff[3]" :key="and">
                <div v-if="index > 0" class="_margin-top:0">
                  or
                </div>
                <div
                  v-for="(i, index) in and"
                  :key="i"
                  class="_display:flex _align-items:center"
                >
                  <i-badge
                    :color="i.showValue === 'isOld' ? 'danger' : i.showValue === 'isNew' ? 'success' : ''"
                    am-param-badge
                    class="_padding:1/4 _margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                  >
                    <p class="_margin:0">
                      {{ i.name }}
                    </p>
                  </i-badge>
                  <div v-if="and.length - 1 > index" class="_margin-left:1 _margin-right:2">and</div>
                </div>
              </div>
            </div>
            <div v-else-if="diff[0] === 'attrs'">
              <p class="_font-weight:bold _margin:0">Attributes</p>
              <i-badge
                color="primary"
                v-for="(attr, index) in diff[3]"
                :key="index"
                :am-tag-badge="attr.id % 10"
                :class="`_padding:1/4 _border _border-color:${attr.isNew ? 'success' : 'danger'} _margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between`"
              >
                <p :line-through="attr.isOld">
                  {{
                    (attr.type[0].toUpperCase() +
                    attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                    ' : ' + attr.name
                  }}
                </p>
              </i-badge>
            </div>
            <div v-else-if="diff[0] === 'images'">
              <p class="_font-weight:bold _margin:0">Images</p>
              <div v-for="img in diff[1]" :key="img">
                <img v-if="!diff[2]?.includes(img)" :src="img" class="_margin:1 _border _border-color:danger">
              </div>
              <div v-for="img in diff[2]" :key="img">
                <img v-if="!diff[1]?.includes(img)" :src="img" class="_margin:1 _border _border-color:success">
              </div>
            </div>
            <div v-else-if="diff[0] === 'images_names'">
              <p class="_font-weight:bold _margin:0">Images names</p>
              <div v-for="img in diff[1]" :key="img">
                <p v-if="!diff[2]?.includes(img)">
                  {{ img }}
                </p>
              </div>
              <div v-for="img in diff[2]" :key="img">
                <p v-if="!diff[1]?.includes(img)" line-through>
                  {{ img }}
                </p>
              </div>
            </div>
          </div>
        </ICard>
      </div>
    </template>
  </i-card>
</template>

<script setup>
import { useStore } from 'vuex'
import DiffMatchPatch from 'diff-match-patch'
const dmp = new DiffMatchPatch()

const store = useStore()
const dateConvert = (publicationDate) => {
  const date = new Date(publicationDate)
  return date.toLocaleString('en', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
const setIsActive = (val) => {
  if (val === 'INACTIVE') return false
  if (val === 'ACTIVE') return true
}
</script>

<style lang="scss">
[am-activity-instruction] {
  [line-through] {
    text-decoration: line-through;
  }
  [am-diff-text] {
    [am-text~='-1'] {
      background-color: var(--color--danger);
      text-decoration: line-through;
    }
    [am-text~='1'] {
      background-color: var(--color--success);
    }
  }
  .form.-dark .radio, .form-group.-dark .radio, .radio.-dark {
    ----border-color: var(--color--gray-70) !important;
  }
}
</style>
